/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Content_Growth_Bullet_3Inputs */

const en_about_content_growth_bullet_3 = /** @type {(inputs: About_Content_Growth_Bullet_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TopTracer technology available free to every range visitor`)
};

const es_about_content_growth_bullet_3 = /** @type {(inputs: About_Content_Growth_Bullet_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tecnología TopTracer disponible gratis para cada visitante del campo de prácticas`)
};

const de_about_content_growth_bullet_3 = /** @type {(inputs: About_Content_Growth_Bullet_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TopTracer-Technologie kostenlos für alle Besucher der Driving Range`)
};

const zh_about_content_growth_bullet_3 = /** @type {(inputs: About_Content_Growth_Bullet_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TopTracer 技术免费向每位练习场访客开放`)
};

const ar_about_content_growth_bullet_3 = /** @type {(inputs: About_Content_Growth_Bullet_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تقنية TopTracer متاحة مجاناً لكل زائر للرينج`)
};

const fr_about_content_growth_bullet_3 = /** @type {(inputs: About_Content_Growth_Bullet_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La technologie TopTracer disponible gratuitement pour chaque visiteur du practice`)
};

const vi_about_content_growth_bullet_3 = /** @type {(inputs: About_Content_Growth_Bullet_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Công nghệ TopTracer miễn phí cho mọi khách đến sân tập`)
};

const sw_about_content_growth_bullet_3 = /** @type {(inputs: About_Content_Growth_Bullet_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teknolojia ya TopTracer inapatikana bila malipo kwa kila mgeni wa uwanja wa mazoezi`)
};

const th_about_content_growth_bullet_3 = /** @type {(inputs: About_Content_Growth_Bullet_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เทคโนโลยี TopTracer ให้บริการฟรีสำหรับผู้มาใช้สนามไดรฟ์กอล์ฟทุกคน`)
};

const bs_about_content_growth_bullet_3 = /** @type {(inputs: About_Content_Growth_Bullet_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TopTracer tehnologija dostupna besplatno svakom posjetiocu vježbališta`)
};

const ja_about_content_growth_bullet_3 = /** @type {(inputs: About_Content_Growth_Bullet_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`すべてのレンジ利用者にTopTracer技術を無料提供`)
};

const ko_about_content_growth_bullet_3 = /** @type {(inputs: About_Content_Growth_Bullet_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TopTracer 기술은 모든 드라이빙 레인지 방문객에게 무료로 제공`)
};

const pt_about_content_growth_bullet_3 = /** @type {(inputs: About_Content_Growth_Bullet_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tecnologia TopTracer disponível gratuitamente para todos os visitantes do driving range`)
};

const it_about_content_growth_bullet_3 = /** @type {(inputs: About_Content_Growth_Bullet_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tecnologia TopTracer disponibile gratuitamente per tutti i frequentatori del campo pratica`)
};

const sv_about_content_growth_bullet_3 = /** @type {(inputs: About_Content_Growth_Bullet_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TopTracer-teknik gratis för alla besökare på drivingrangen`)
};

const nl_about_content_growth_bullet_3 = /** @type {(inputs: About_Content_Growth_Bullet_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TopTracer-technologie gratis beschikbaar voor alle bezoekers van de driving range`)
};

const da_about_content_growth_bullet_3 = /** @type {(inputs: About_Content_Growth_Bullet_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TopTracer-teknologi gratis for alle besøgende på driving rangen`)
};

const nb_about_content_growth_bullet_3 = /** @type {(inputs: About_Content_Growth_Bullet_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TopTracer-teknologi gratis for alle besøkende på drivingrangen`)
};

const fi_about_content_growth_bullet_3 = /** @type {(inputs: About_Content_Growth_Bullet_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TopTracer-teknologia maksutta jokaisen rangekävijän käytössä`)
};

const pl_about_content_growth_bullet_3 = /** @type {(inputs: About_Content_Growth_Bullet_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Technologia TopTracer dostępna bezpłatnie dla każdego gościa driving range`)
};

const ru_about_content_growth_bullet_3 = /** @type {(inputs: About_Content_Growth_Bullet_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Технология TopTracer бесплатно доступна всем посетителям тренировочного поля`)
};

const tr_about_content_growth_bullet_3 = /** @type {(inputs: About_Content_Growth_Bullet_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TopTracer teknolojisi her driving range ziyaretçisine ücretsiz`)
};

const hi_about_content_growth_bullet_3 = /** @type {(inputs: About_Content_Growth_Bullet_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ड्राइविंग रेंज पर आने वाले हर व्यक्ति के लिए TopTracer तकनीक मुफ़्त`)
};

const id_about_content_growth_bullet_3 = /** @type {(inputs: About_Content_Growth_Bullet_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teknologi TopTracer tersedia gratis untuk setiap pengunjung lapangan latihan`)
};

const ms_about_content_growth_bullet_3 = /** @type {(inputs: About_Content_Growth_Bullet_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teknologi TopTracer disediakan percuma untuk setiap pengunjung lapang latihan`)
};

const cs_about_content_growth_bullet_3 = /** @type {(inputs: About_Content_Growth_Bullet_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Technologie TopTracer zdarma pro každého návštěvníka driving range`)
};

const el_about_content_growth_bullet_3 = /** @type {(inputs: About_Content_Growth_Bullet_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Τεχνολογία TopTracer δωρεάν για κάθε επισκέπτη του driving range`)
};

const he_about_content_growth_bullet_3 = /** @type {(inputs: About_Content_Growth_Bullet_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`טכנולוגיית TopTracer זמינה בחינם לכל מבקר במגרש האימונים`)
};

const af_about_content_growth_bullet_3 = /** @type {(inputs: About_Content_Growth_Bullet_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TopTracer-tegnologie gratis beskikbaar vir elke besoeker aan die oefenbaan`)
};

const hu_about_content_growth_bullet_3 = /** @type {(inputs: About_Content_Growth_Bullet_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A TopTracer technológia ingyenesen elérhető a gyakorlópálya minden látogatójának`)
};

/**
* | output |
* | --- |
* | "TopTracer technology available free to every range visitor" |
*
* @param {About_Content_Growth_Bullet_3Inputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const about_content_growth_bullet_3 = /** @type {((inputs?: About_Content_Growth_Bullet_3Inputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Content_Growth_Bullet_3Inputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_about_content_growth_bullet_3(inputs)
	if (locale === "de") return de_about_content_growth_bullet_3(inputs)
	if (locale === "zh") return zh_about_content_growth_bullet_3(inputs)
	if (locale === "ar") return ar_about_content_growth_bullet_3(inputs)
	if (locale === "fr") return fr_about_content_growth_bullet_3(inputs)
	if (locale === "vi") return vi_about_content_growth_bullet_3(inputs)
	if (locale === "sw") return sw_about_content_growth_bullet_3(inputs)
	if (locale === "th") return th_about_content_growth_bullet_3(inputs)
	if (locale === "bs") return bs_about_content_growth_bullet_3(inputs)
	if (locale === "ja") return ja_about_content_growth_bullet_3(inputs)
	if (locale === "ko") return ko_about_content_growth_bullet_3(inputs)
	if (locale === "pt") return pt_about_content_growth_bullet_3(inputs)
	if (locale === "it") return it_about_content_growth_bullet_3(inputs)
	if (locale === "sv") return sv_about_content_growth_bullet_3(inputs)
	if (locale === "nl") return nl_about_content_growth_bullet_3(inputs)
	if (locale === "da") return da_about_content_growth_bullet_3(inputs)
	if (locale === "nb") return nb_about_content_growth_bullet_3(inputs)
	if (locale === "fi") return fi_about_content_growth_bullet_3(inputs)
	if (locale === "pl") return pl_about_content_growth_bullet_3(inputs)
	if (locale === "ru") return ru_about_content_growth_bullet_3(inputs)
	if (locale === "tr") return tr_about_content_growth_bullet_3(inputs)
	if (locale === "hi") return hi_about_content_growth_bullet_3(inputs)
	if (locale === "id") return id_about_content_growth_bullet_3(inputs)
	if (locale === "ms") return ms_about_content_growth_bullet_3(inputs)
	if (locale === "cs") return cs_about_content_growth_bullet_3(inputs)
	if (locale === "el") return el_about_content_growth_bullet_3(inputs)
	if (locale === "he") return he_about_content_growth_bullet_3(inputs)
	if (locale === "af") return af_about_content_growth_bullet_3(inputs)
	if (locale === "hu") return hu_about_content_growth_bullet_3(inputs)
	return en_about_content_growth_bullet_3(inputs)
});